import { Col, notification } from "antd";
import { useState, useEffect, useRef } from "react";
import dummyFace from "../../assets/dummyFace.png";
import { PrimaryButton } from "../styled/Button.styled";

type ImageUploaderProps = {
  src?: string;
  name?: string;
  id?: string;
  type?: string;
  imageHandler?: any;
  setImg?: any;
  setCategoryImageUpload?: any;
};

const imageUploaderStyle: React.CSSProperties = {
  width: "8rem",
  height: "6rem",
  objectFit: "cover",
  border: "1px solid #ccc",
  borderRadius: "4px",
};

function ImageUploader(props: ImageUploaderProps) {
  const { src, type, id, name, setImg, setCategoryImageUpload } = props;
  const [imageSrc, setImageSrc] = useState<string | undefined>("");
  const fileInputRef = useRef<HTMLInputElement>(null);

  const imageHandler = (e: any) => {
    const file = e.target.files[0];
    if (!file) return;

    const newData = new FormData();
    const image_as_base64 = URL.createObjectURL(file);
    const fileType = file.type;

    const acceptedImagesTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!acceptedImagesTypes.includes(fileType)) {
      notification.error({
        message: "Please upload image only",
        placement: "bottomLeft",
      });
      return;
    }

    newData.append("image", file);
    setCategoryImageUpload(newData);
    setImg({
      image_preview: image_as_base64,
      image_file: file,
    });
  };

  useEffect(() => {
    if (!src || src.includes("undefined") || src.includes("null")) {
      setImageSrc(dummyFace);
    } else {
      setImageSrc(src);
    }
  }, [src]);

  return (
    <>
      <Col span={6}>
        <img src={imageSrc} style={imageUploaderStyle} alt="category-img" />
      </Col>
      <Col>
        <input
          type="file"
          ref={fileInputRef}
          accept="image/*"
          style={{ display: "none" }}
          onChange={imageHandler}
        />
        <PrimaryButton
          htmlType="button"
          onClick={() => fileInputRef.current?.click()}
          style={{
            marginLeft: "1rem",
            backgroundColor: "#3e4685",
            color: "#fff",
            border: "5px",
            padding: "2px",
            borderRadius: "4px",
            width:"100%",
            fontSize:"14px",
            height:"30px",
          }}
        >
          Upload Image
        </PrimaryButton>
      </Col>
    </>
  );
}

export default ImageUploader;
